import co2 from "./co2.js";
import hosting from "./hosting-node.js";
import averageIntensity from "./data/average-intensities.min.js";
import marginalIntensity from "./data/marginal-intensities-2021.min.js";
export { co2, hosting, averageIntensity, marginalIntensity };
